import { logger } from '../../../../utils/common/logger'
import { LoginRadiusAdapter } from '../loginradius'

interface IWindow extends Window {
    Sailthru: {
        integration: (eventName: string, options: any) => {}
        init(options: { customerId: string }): void
    }

}

declare let window: IWindow

export default class SailthruAdapter {
    // tslint:disable-next-line:no-empty
    constructor() {
    }

    /**
     * Set cookie with userSignUp from the Sailthru JS Library
     * This automatically sets the cookie
     * Reference: https://getstarted.sailthru.com/developers/api-client/javascript/#userSignUp
     *
     * @param email: string - user email
     * @param redirectUrl: string - url to redirect to after signup (used by LR)
     * @param token: string - login access token
     */
    public static setCookie(email: string, redirectUrl?: string, token?: string): void {
        window.Sailthru.integration('userSignUp', {
            email,
            lists: {},
            onError: (err: any) => {
                logger('error', 'Sailthru cookie set failed', err)
                if (redirectUrl && token) {
                    location.replace(`${LoginRadiusAdapter.ssoRedirectLink}&token=${token}&callback=${redirectUrl}`)
                }
            },
            onSuccess: () => {
                logger('info', 'Sailthru cookie set successfully')
                if (redirectUrl && token) {
                    location.replace(`${LoginRadiusAdapter.ssoRedirectLink}&token=${token}&callback=${redirectUrl}`)
                }
            }
        })
    }
}
